import { LISTED_CONTACTS as SET_LISTED_CONTACTS } from "./actions";
import React from "react";

let initialState = null;

export const reducer = (state = initialState, action) => {
	switch (action.type) {
	case SET_LISTED_CONTACTS:
		return action.listedContacts;
		break;
	default:
		return state;
		break;
	}
};
